module.exports = __webpack_public_path__ + "static/media/grapes.7fa16f3a.gif";